import "./Dashboard.css";
import "shared/extensions/date";

import { GroupingValues } from "../../UIPalette/components/Reports/ReportConstants";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { ChangeEvent, useReducer, useState } from "react";
import { ReportFilters } from "./components/Filters/ReportFilters";
import { filtersReducer } from "./components/Filters/filtersReducer";
import { useTranslation } from "react-i18next";
import { Select } from "shared/UI/Select/Select";
import { DashboardReport, DashboardReportData, useReportsData } from "./components/useReportsData";

export type FilterVisibility = {
  hideDateFilters?: boolean;
  hideAllFilters?: boolean;
  hideLocaleFilter?: boolean;
  hideGrouping?: boolean;
};

export const Dashboard = () => {
  const { t } = useTranslation();
  const [report, setReport] = useState<DashboardReportData>();

  const [filterVisibility, setFilterVisibility] = useState({
    hideDateFilters: true,
    hideAllFilters: false,
    hideLocaleFilter: false,
    hideGrouping: false,
  });

  const { reportsData } = useReportsData();
  const [filters, dispatch] = useReducer(filtersReducer, {
    dateFrom: Date.fromOffset(new Date(), -30).toDateOnly(),
    dateTo: new Date().toDateOnly(),
    groupBy: GroupingValues.None.toString(),
  });

  const enableFilters = (visibilityFilters?: FilterVisibility) =>
    setFilterVisibility({
      ...{
        hideDateFilters: false,
        hideAllFilters: false,
        hideLocaleFilter: false,
        hideGrouping: false,
      },
      ...visibilityFilters,
    });

  const handleSelectReport = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedReport = reportsData.find((data) => data.report === e.target.value);
    enableFilters(selectedReport?.children[0].visibilityFilters);
    setReport(selectedReport);
  };

  const reportFilters = (
    <ReportFilters
      filters={filters}
      dispatch={dispatch}
      hideAllFilters={filterVisibility.hideAllFilters}
      hideDateFilters={filterVisibility.hideDateFilters}
      hideLocaleFilter={filterVisibility.hideLocaleFilter}
      hideGrouping={filterVisibility.hideGrouping}
    />
  );

  return (
    <div className="space-y-4">
      <h2 className="text-font-dark mb-3.5">{t("dashboard.title")}</h2>
      <div className="w-full max-w-[300px]">
        <Select
          onChange={handleSelectReport}
          aria-label={t("dashboard.reportTypeLabel")}
          label={t("dashboard.reportTypeLabel")}
          placeholder={t("dashboard.reportTypeLabel")}
          value={report?.report}
        >
          {reportsData.map((data, index: number) => (
            <option key={index}>{data.report}</option>
          ))}
        </Select>
      </div>
      {!!report && (
        <Tabs selectedTabClassName="decoration-2 decoration-primary-700 !border-brand-purple-light outline-none">
          {report.children.length > 1 && (
            <TabList className="selected-tab pb-10">
              {report.children.map((child: DashboardReport, index: number) => (
                <Tab
                  key={index}
                  className="tab"
                  onClick={() => enableFilters(child.visibilityFilters)}
                >
                  {child.title}
                </Tab>
              ))}
            </TabList>
          )}
          {reportFilters}
          {report.children.length > 1 ? (
            report.children.map((child: DashboardReport, index: number) => (
              <TabPanel key={index}>{child.panel(filters)}</TabPanel>
            ))
          ) : (
            report.children[0].panel(filters)
          )}
        </Tabs>
      )}
    </div>
  );
};
